import React, { useState } from "react";
import { toast } from "react-toastify";
import { updateGuarantor } from "services/userService";

// components

export default function UpdateDetails() {
  let [guarantor, setGuarantor] = useState("");
  let [accountNumber, setAccountNumber] = useState("");

  let testStyle1 =
    "border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150";

  async function submitPurchase() {
    toast.info("Processing");
    let data = {
      guarantor,
      accountNumber,
      };
      
      if (guarantor === "" || accountNumber === "") return toast.error("All fields are required")
      if(accountNumber.length !== 10) return toast.error("Account Number must be 10 Digit")

    try {
      await updateGuarantor(data);
      toast.success("Account Updated Successfully");
      window.location = "/dashboard/dashboard";
    } catch (error) {
      toast.error(error.response?.data);
    }
  }

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">
              Account Update
            </h6>
          </div>
        </div>
        <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form>
<br />            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Guarantor's Name
                  </label>
                  <input
                    type="text"
                    className={testStyle1}
                    value={guarantor}
                    onChange={(e) => setGuarantor(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Confirm Account Number
                  </label>
                  <input
                    type="number"
                    className={testStyle1}
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Action
                  </label>
                  <button
                    type="button"
                    style={{ backgroundColor: "#558000", color: "white" }}
                    onClick={() => {
                      submitPurchase();
                    }}
                    className=" active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  >
                    Update Account
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
